'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyle = exports.Themes = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n\n    *{\n        padding: 0;\n        margin: 0;\n        box-sizing: border-box;\n        list-style: none;\n    }\n\n    body, html{\n        padding: 0;\n        margin: 0;\n        background: whitesmoke;\n        font-family: Quicksand, Helvetica, sans-serif;\n        background: ', ';\n        color: ', ';\n        scroll-behavior: smooth;\n    }\n    \n    \n    a {\n        color: inherit;\n        text-decoration: none;\n    }\n    \n    svg{\n        min-height: 25px;\n        min-width: 25px;\n    }\n    p a {\n        text-decoration: underline;\n    }\n    \n    .zyppd-background{\n        background: rgb(67,232,150);\n        background: radial-gradient(\n        farthest-side at bottom left,\n        rgba(67,232,150,1), \n        transparent\n        ),\n        radial-gradient(\n        farthest-corner at bottom right,\n        rgba(105, 50, 200, 1), \n        rgba(67,232,150,1)\n        );\n\n    }\n\n    .zyppd__menu{\n        z-index: 40;\n        position: relative;\n    }\n    \n'], ['\n\n    *{\n        padding: 0;\n        margin: 0;\n        box-sizing: border-box;\n        list-style: none;\n    }\n\n    body, html{\n        padding: 0;\n        margin: 0;\n        background: whitesmoke;\n        font-family: Quicksand, Helvetica, sans-serif;\n        background: ', ';\n        color: ', ';\n        scroll-behavior: smooth;\n    }\n    \n    \n    a {\n        color: inherit;\n        text-decoration: none;\n    }\n    \n    svg{\n        min-height: 25px;\n        min-width: 25px;\n    }\n    p a {\n        text-decoration: underline;\n    }\n    \n    .zyppd-background{\n        background: rgb(67,232,150);\n        background: radial-gradient(\n        farthest-side at bottom left,\n        rgba(67,232,150,1), \n        transparent\n        ),\n        radial-gradient(\n        farthest-corner at bottom right,\n        rgba(105, 50, 200, 1), \n        rgba(67,232,150,1)\n        );\n\n    }\n\n    .zyppd__menu{\n        z-index: 40;\n        position: relative;\n    }\n    \n']);

var _styledComponents = require('styled-components');

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var commonStyles = {
  shadow: '0 1px 1px rgba(0,0,0,0.15), 0 2px 2px rgba(0,0,0,0.10), 0 4px 4px rgba(0,0,0,0.05);',
  // shadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
  expandedShadow: '0 7px 18px rgba(0,0,0,0.1), 0 4px 5px rgba(0,0,0,0.15)',
  warning: '#db3a32',
  borderRadius: '.2em'
};
var stateColors = {
  positive: '#43E896',
  success: '#43E896',
  error: '#E84747',
  negative: '#E84747',
  warning: '#F4D217',
  disabled: '#9AA6B3',
  default: '#323233'
};

var Themes = exports.Themes = function Themes() {
  var brandColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#43E896";
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["white", "#ededed"];

  var pallete = range.length && _chromaJs2.default.scale(range).mode('lch').colors(3);

  var mainColor = range ? range[0] : theme;
  var textColor = (0, _chromaJs2.default)(range[0]).luminance() > 0.4 ? '#333' : 'whitesmoke';
  return _extends({}, commonStyles, {
    pallete: pallete,
    textColor: textColor,
    secondaryTextColor: (0, _chromaJs2.default)(textColor).darken(1),
    disabledForeground: (0, _chromaJs2.default)(pallete[0]).darken(0.3),
    foreground: pallete[0],
    middleground: pallete[1],
    background: pallete[2],
    highlight: 'red',
    brandColor: brandColor,
    stateColors: _extends({}, stateColors)
  });
};

var GlobalStyle = exports.GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.textColor;
});